import CustomButton from '../../../common/components/CustomButton';

type AuthorCopyrightTransferFormView2FieldName = 'address'|'name';

export default function AuthorCopyrightTransferFormView2({
  document,
  getValue,
  karaokeOrder,
  karaokeAuthor,
  onNext,
  onBack,
} : {
  document: string,
  getValue: (name: AuthorCopyrightTransferFormView2FieldName) => string,
  karaokeOrder: {
    applicant_name: string,
    applicant_address: string,
  },
  karaokeAuthor: {
    pseudonym: string,
  },
  onNext: () => void,
  onBack: () => void,
}) {
  return (
    <>
      <h2>確認画面</h2>
      <p className="mb50">入力内容に誤りがないか確認し、「契約する」を押してください。</p>
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: document }} />
      <div className="loader_parts_container">
        <form className="cake_ajax_form">
          <div className="form__body">
            <dl>
              { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
              <dt><label>甲</label></dt>
              <dd>
                <ul className="col" style={{ float: 'none' }}>
                  <li className="col span_24">
                    <span className="col span_6">筆名:</span>
                    <span className="col span_18">{karaokeAuthor.pseudonym}</span>
                  </li>
                  <li className="col span_24">
                    <span className="col span_6">
                      本名
                      <span className="asterisk">※</span>
                    </span>
                    <span className="col span_18">
                      {getValue('name')}
                    </span>
                  </li>
                  <li className="col span_24">
                    <span className="col span_6">
                      住所
                      <span className="asterisk">※</span>
                    </span>
                    <span className="col span_18">
                      {getValue('address')}
                    </span>
                  </li>
                </ul>
              </dd>
            </dl>
            <dl>
              { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
              <dt><label>乙</label></dt>
              <dd>
                <ul className="col" style={{ float: 'none' }}>
                  <li className="col span_24">
                    <span className="col span_6">
                      本名
                      <span className="asterisk">※</span>
                    </span>
                    <span className="col span_18">
                      {karaokeOrder.applicant_name}
                    </span>
                  </li>
                  <li className="col span_24">
                    <span className="col span_6">
                      住所
                      <span className="asterisk">※</span>
                    </span>
                    <span className="col span_18">
                      {karaokeOrder.applicant_address}
                    </span>
                  </li>
                </ul>
              </dd>
            </dl>
            <ul>
              <li className="bt">
                <CustomButton type="cancel-split" onClick={() => onBack()}>戻る</CustomButton>
                <CustomButton type="default-split" onClick={() => onNext()}>契約する</CustomButton>
              </li>
            </ul>
          </div>
        </form>
      </div>
    </>
  );
}
